import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { Button } from 'components/Button/Button'

import LiveModal from '../LiveModal'

import './_endModal.scss'

type LeaveStreamProps = {
  onClose: () => void
  onConfirm: () => void | Promise<void>
}

const LeaveStream = ({ onClose, onConfirm }: LeaveStreamProps) => {
  const { t } = useTranslation()
  const [isLeaving, setIsLeaving] = useState(false)

  const handleConfirm = async () => {
    if (isLeaving) return

    try {
      setIsLeaving(true)
      await onConfirm()
    } finally {
      setIsLeaving(false)
    }
  }

  return (
    <LiveModal
      title='Leave Stream'
      onClose={isLeaving ? () => {} : onClose}
      customClass='endmodal'
    >
      <div className='endmodal'>
        <p className='endmodal__note'>
          {'Are You Sure You Want To Leave This LiveStream'}
        </p>

        <div className='endmodal__buttons'>
          <Button
            text={t('cancel')}
            color='dark-grey'
            font='mont-14-normal'
            type='transparent--borderless'
            width='fit'
            height='3'
            padding='1-15'
            clickFn={isLeaving ? () => {} : onClose}
          />

          <Button
            text={isLeaving ? 'Leaving...' : 'Leave'}
            color='transparent'
            font='mont-14-normal'
            type='transparent--blue'
            width='fit'
            height='3'
            padding='1-15'
            clickFn={handleConfirm}
          />
        </div>
      </div>
    </LiveModal>
  )
}

export default LeaveStream